import React, { useState } from 'react';

const ShrinkSleeves = ({ product, updateProduct }) => {
  const [application, setApplication] = useState(product.fields.application || 'Pre-Cut');
  const [rollingDirection, setRollingDirection] = useState(product.fields.rollingDirection || '');

  const handleSizeChange = (dimension, value) => {
    const size = { ...product.fields.size, [dimension]: value };
    if (dimension === 'heightMM') {
      size.height = (value / 25.4).toFixed(2);
    }
    if (dimension === 'widthMM') {
      size.width = (value / 25.4).toFixed(2);
    }
    updateProduct('size', size);
  };

  const handleFinishesChange = (finish) => {
    let finishes = product.fields.finishes ? product.fields.finishes.split(',') : [];
    if (finishes.includes(finish)) {
      finishes = finishes.filter(f => f !== finish);
    } else {
      finishes.push(finish);
    }
    updateProduct('finishes', finishes.join(','));
  };

  const handleSpecialEffectsChange = (effect) => {
    let effects = product.fields.specialEffects ? product.fields.specialEffects.split(',') : [];
    if (effects.includes(effect)) {
      effects = effects.filter(e => e !== effect);
    } else {
      effects.push(effect);
    }
    updateProduct('specialEffects', effects.join(','));
  };

  const handleApplicationChange = (value) => {
    setApplication(value);
    updateProduct('application', value);
  };

  const handleRollingDirectionChange = (e) => {
    const direction = e.target.value;
    setRollingDirection(direction);
    updateProduct('rollingDirection', direction);
  };

  const specialEffectsOptions = [
    'Hologram Stamping',
    'Silver Ink',
    'Variable Data',
    'Hot Stamping 2 Colors',
    'Spot UV',
    'Invisible Black Light Ink',
    'Cold Stamping',
    'Raised Varnish',
    'Cold Stamping 2 Colors',
    'Soft Touch Finish',
    'Perforation',
    'Hot Stamping'
  ];

  return (
    <div className="product-form grid gap-2 grid-cols-2">
      <div className="form-group col-span-2">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Material: <span className="text-red-500">*</span></label>
        <select
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          value={product.fields.material || ""}
          onChange={(e) => updateProduct('material', e.target.value)}
          required
        >
          <option value="">Select Material</option>
          <option value="PETG">PETG</option>
          <option value="PVC">PVC</option>
        </select>
      </div>

      <div className=" col-span-2 mb-2">
        <label className="block tracking-wide text-sm font-bold leading-6 mb-5 text-gray-900">Finishes: <span className="text-red-500">*</span></label>
        <div className="grid gap-2 grid-cols-2">
          {[
            'Spot UV',
            'Matte',
            'Soft Touch',
            'Gloss'
          ].map((finish) => (
            <label key={finish} className="tracking-wide text-xs font-bold leading-6 text-gray-900 flex w-full flex-row" style={{ justifySelf: 'flex-start' }}>
              <input
                type="checkbox"
                checked={product.fields.finishes?.split(',').includes(finish) || false}
                onChange={() => handleFinishesChange(finish)}
                className="mr-2 text-gray-900 dark:text-gray-300"
                style={{ width: '15px', height: '15px' }}
                required
              />
              {finish}
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Height: (in mm) <span className="text-red-500">*</span></label>
        <input
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          type="number"
          value={product.fields.size?.heightMM || ""}
          onChange={(e) => handleSizeChange('heightMM', e.target.value)}
          placeholder="Height in mm"
          required
        />
      </div>

      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Width: (in mm) <span className="text-red-500">*</span></label>
        <input
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          type="number"
          value={product.fields.size?.widthMM || ""}
          onChange={(e) => handleSizeChange('widthMM', e.target.value)}
          placeholder="Width in mm"
          required
        />
      </div>

      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-red-500">Height: (in Inches)</label>
        <input
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          type="number"
          value={product.fields.size?.height || ""}
          readOnly
          placeholder="Height"
        />
      </div>

      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-red-500">Width: (in Inches)</label>
        <input
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          type="number"
          value={product.fields.size?.width || ""}
          readOnly
          placeholder="Width"
        />
      </div>

      <div className="col-span-2 mb-2">
        <label className="block tracking-wide text-sm font-bold leading-6 mb-5 text-gray-900">Application:</label>
        <div className="flex">
          <label className="mr-4">
            <input
              type="radio"
              name="application"
              value="Pre-Cut"
              checked={application === 'Pre-Cut'}
              onChange={() => handleApplicationChange('Pre-Cut')}
              className="mr-2"
            />
            Pre-Cut
          </label>
          <label>
            <input
              type="radio"
              name="application"
              value="On a Roll"
              checked={application === 'On a Roll'}
              onChange={() => handleApplicationChange('On a Roll')}
              className="mr-2"
            />
            On a Roll
          </label>
        </div>
      </div>

      {application === 'On a Roll' && (
        <div className="col-span-2 mb-2">
          <label className="block tracking-wide text-sm font-bold leading-6 mb-5 text-gray-900">Pick a rolling direction:</label>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            value={rollingDirection}
            onChange={handleRollingDirectionChange}
          >
            <option value="">Select Direction</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </select>
        </div>
      )}

      <div className="col-span-2 mb-2">
        <label className="block tracking-wide text-sm font-bold leading-6 mb-5 text-gray-900">Special Effects:</label>
        <div className="grid gap-2 grid-cols-3">
          {specialEffectsOptions.map((effect) => (
            <label key={effect} className="tracking-wide text-xs font-bold leading-6 text-gray-900 flex w-full flex-row" style={{ justifySelf: 'flex-start' }}>
              <input
                type="checkbox"
                checked={product.fields.specialEffects?.split(',').includes(effect) || false}
                onChange={() => handleSpecialEffectsChange(effect)}
                className="mr-2 text-gray-900 dark:text-gray-300"
                style={{ width: '15px', height: '15px' }}
              />
              {effect}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShrinkSleeves;
